import React from 'react';
import {
    Card,
    CardBody,
    Input,
    Label,
    FormGroup,
    Row,
    Badge,
} from 'reactstrap';
import { Colxx } from '../../../components/common/CustomBootstrap';
import { AddCommaNumber, CleanPrice } from '../../../helpers/Utils';
import PriceInput from '../../../components/common/PriceInput';

// Helper function để xóa dấu phẩy từ số
const removeComma = (str) => CleanPrice(str);

const StockInfo = ({
    quantity = '',
    costPrice = '',
    sellingPrice = '',
    onChangeQuantity,
    onChangeCostPrice,
    disabled = false,
    quantityLabel = 'Số lượng nhập',  // Default label, có thể override thành "Tồn kho"
    quantityDisabled = false,  // Cho phép disable riêng trường quantity
    costPriceDisabled = false,  // Cho phép disable riêng trường giá vốn
    quantityPlaceholder = 'Nhập số lượng',
    costPricePlaceholder = 'Nhập giá vốn',
    title = 'Tạo tồn kho',
}) => {
    // Tính % lợi nhuận: (Doanh thu - Giá vốn) / Doanh thu * 100%
    const calculateProfit = () => {
        const cost = parseFloat(removeComma(costPrice)) || 0;
        const sell = parseFloat(removeComma(sellingPrice)) || 0;
        
        if (cost <= 0 || sell <= 0) return null;
        
        const profit = sell - cost;
        // Công thức: (Tổng Doanh thu – Giá vốn) / Tổng Doanh thu x 100%
        const profitPercent = ((profit / sell) * 100).toFixed(1);
        
        return {
            profit,
            profitPercent,
            isPositive: profit >= 0
        };
    };

    // Tính tổng giá vốn
    const totalCost = () => {
        const qty = parseFloat(removeComma(quantity)) || 0;
        const cost = parseFloat(removeComma(costPrice)) || 0;
        return qty * cost;
    };

    const profitInfo = calculateProfit();
    const total = totalCost();

    return (
        <div className="stock-info mb-4">
            {/* Header */}
            <div className="d-flex align-items-center mb-3">
                <i className="simple-icon-layers mr-2" style={{ fontSize: '18px' }} />
                <Label className="mb-0 font-weight-bold">
                    {title}
                </Label>
            </div>

            <Card className="border">
                <CardBody className="p-3">
                    <Row>
                        {/* Số lượng nhập / Tồn kho */}
                        <Colxx xxs="6" className="pr-2 has-float-label">
                            <FormGroup className="mb-0">
                                <Label className="text-muted text-small">
                                    {quantityLabel}
                                </Label>
                                <PriceInput
                                    value={quantity}
                                    placeholder={quantityPlaceholder}
                                    onChange={(val) => onChangeQuantity && onChangeQuantity(val)}
                                    disabled={disabled || quantityDisabled}
                                />
                            </FormGroup>
                        </Colxx>

                        {/* Giá vốn */}
                        <Colxx xxs="6" className="has-float-label pl-0">
                            <FormGroup className="mb-0">
                                <Label className="text-muted text-small">
                                    Giá vốn/đơn vị
                                </Label>
                                <PriceInput
                                    value={costPrice}
                                    placeholder={costPricePlaceholder}
                                    onChange={(val) => onChangeCostPrice && onChangeCostPrice(val)}
                                    disabled={disabled || costPriceDisabled}
                                />
                            </FormGroup>
                        </Colxx>
                    </Row>

                    {/* Thông tin tính toán */}
                    {(total > 0 || profitInfo) && (
                        <div className="d-flex justify-content-between align-items-center pt-2 mt-3 border-top">
                            {/* Tổng giá vốn */}
                            {total > 0 && (
                                <div>
                                    <div className="text-small text-muted mr-2 mb-2">Tổng giá vốn:</div>
                                    <div className="font-weight-bold text-primary">
                                        {AddCommaNumber(Math.round(total))}đ
                                    </div>
                                </div>
                            )}

                            {/* Lợi nhuận dự kiến */}
                            {profitInfo && (
                                <div>
                                    <div className="text-small text-muted mr-2 mb-2">Lợi nhuận:</div>
                                    <div
                                        className={profitInfo.isPositive ? 'font-weight-bold text-success' : 'font-weight-bold text-danger'}
                                        style={{ fontSize: '13px' }}
                                    >
                                        {profitInfo.isPositive ? '+' : ''}{profitInfo.profitPercent}%
                                        ({AddCommaNumber(Math.round(profitInfo.profit))}đ)
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </CardBody>
            </Card>
        </div>
    );
};

export default StockInfo;
